import img1 from '../../../images/story-girl-and-snowman.svg'
import img2 from '../../../images/story-batman-catwoman-and-ghost.svg'
import img3 from '../../../images/story-girl-and-boy.svg'
import img4 from '../../../images/story-kids-and-kind-guy.svg'

export const slidesData = [
    {
        id: 0,
        info1: 'Create and share the', 
        info2: 'animation movie that',
        info3: 'makes you laugh',
        src: img1
    },
    {
        id: 1,
        info1: 'Create and share the', 
        info2: 'animation movie that',
        info3: 'keeps you engaged',
        src: img2
    },
    {
        id: 2,
        info1: 'Create and share the', 
        info2: 'animation movie that',
        info3: 'makes you smile',
        src: img3
    },
    {
        id: 3,
        info1: 'Create and share the', 
        info2: 'animation movie that',
        info3: 'tells your story',
        src: img4
    }
]